module.exports = __webpack_public_path__ + "static/media/PeerFiveAdminScreen.cb4da365.svg";